import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import Icon from '@mdi/react';
import { ButtonBar } from 'components';
import { Field } from 'formik';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-size: 18px;
    line-height: 1.22;
    color: ${Variables.Colors.n70};
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const FormField = styled(Field)`
    max-width: 420px;
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const ButtonGroup = styled(ButtonBar)`
    margin-top: 32px;
    margin-bottom: 16px;
`;

export const InputCol = styled.div``;

export const InputRow = styled.div`
    display: flex;
    ${InputCol} {
        width: 100px;
        &:nth-of-type(2) {
            margin-left: 16px;
        }
    }
`;

export const WrapperIcon = styled(Icon)``;

export const InfoWrapper = styled.div`
    margin-top: 16px;
    display: flex;
    align-items: center;

    ${WrapperIcon} {
        fill: ${Variables.Colors.amber20};
    }
`;

export const InfoLabel = styled.div`
    margin-left: 8px;
    font-weight: 500;
`;
